import watchListCommon from './common';
import watchListNews from './news';
import watchListFundamental from './fundamental';
import watchListPerformance from './performance';
import watchListSummary from './summary';
import watchListTechnical from './technical';
import coveredWarrant from './coveredWarrant';

export default {
  watchListCommon,
  watchListNews,
  watchListFundamental,
  watchListPerformance,
  watchListSummary,
  watchListTechnical,
  coveredWarrant,
};
